import chapter1ru from'./chapter1ru';
import chapter2ru from'./chapter2ru';
import chapter3ru from'./chapter3ru';

const plotRu = [
  ...chapter1ru,
  ...chapter2ru,
  ...chapter3ru
];

export default plotRu;
